var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import Icon from '../../../components/Icon';
import Input from '../../../components/Input';
import { ActiveLimit, ExtraLimit, PendingLimit, ConfirmLimit, DeletedLimit, TransactionLimit, CooldownLimit } from '../LimitStatus';
import { FormattedNumber } from 'react-intl';
import Button from '../../../components/Button';
import Translate from '../../../components/Translate';
import translate from '../../../lib/utils/translate';

var AmountItemContent = function (_Component) {
  _inherits(AmountItemContent, _Component);

  function AmountItemContent(props) {
    _classCallCheck(this, AmountItemContent);

    return _possibleConstructorReturn(this, (AmountItemContent.__proto__ || Object.getPrototypeOf(AmountItemContent)).call(this, props));
  }

  _createClass(AmountItemContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          intl = _props.intl,
          currency = _props.currency,
          _props$config = _props.config,
          config = _props$config === undefined ? [] : _props$config,
          type = _props.type,
          title = _props.title,
          timespan = _props.timespan,
          amount = _props.amount,
          handleLimitAmount = _props.handleLimitAmount,
          handleLimitTimespan = _props.handleLimitTimespan,
          handleIncrement = _props.handleIncrement,
          handleDecrement = _props.handleDecrement,
          activeLimit = _props.activeLimit,
          multipleLimits = _props.multipleLimits,
          canceledLimit = _props.canceledLimit,
          handleDecline = _props.handleDecline,
          handleConfirm = _props.handleConfirm,
          transactionLimit = _props.transactionLimit,
          handleCancel = _props.handleCancel,
          handlePickLimit = _props.handlePickLimit,
          pendingLimit = _props.pendingLimit,
          reviewLimit = _props.reviewLimit,
          submitButton = _props.submitButton,
          confirmLimit = _props.confirmLimit,
          jurisdiction = _props.jurisdiction,
          isLoading = _props.isLoading,
          cooldownLimit = _props.cooldownLimit,
          timeUntilNewLimit = _props.timeUntilNewLimit,
          timeUntilConfirm = _props.timeUntilConfirm,
          timeUntilDelete = _props.timeUntilDelete,
          hasDepositLimitIncreaseBlock = _props.hasDepositLimitIncreaseBlock,
          limits = _props.limits;


      var activeLimits = limits && limits.filter(function (l) {
        return l.Type === type && ['Active'].includes(l.Status);
      }) || [];
      var hideDeleteButton = type === 'Deposit' && jurisdiction && (jurisdiction.toLowerCase() === 'sga' || activeLimits.length <= 1 && jurisdiction.toLowerCase() === 'dga');

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'limit-container' },
          React.createElement(
            'div',
            { className: 'timespan-selector' },
            config.map(function (item) {
              return React.createElement(
                'button',
                {
                  onClick: function onClick() {
                    handleLimitTimespan(item);
                  },
                  value: timespan,
                  type: 'button',
                  name: 'Timespan',
                  className: 'button primary' + (timespan === item.value ? ' selected' : ''),
                  key: item.value },
                translate({
                  id: item.label
                }, intl)
              );
            })
          ),
          timespan !== 0 && React.createElement(
            'div',
            null,
            activeLimit && !multipleLimits && React.createElement(ActiveLimit, {
              amount: activeLimit.Amount || '',
              remainingAmount: activeLimit.RemainingAmount,
              status: activeLimit.Status,
              timespan: activeLimit.Timespan,
              currency: currency,
              type: type
            }),
            multipleLimits && React.createElement(
              Fragment,
              null,
              React.createElement(
                'div',
                { className: 'extra-limit-message' },
                React.createElement(Translate, {
                  id: 'label.extra-limits',
                  defaultMessage: 'You seem to have multiple limits on your account, pick the one you want:'
                })
              ),
              multipleLimits.map(function (limit) {
                return React.createElement(ExtraLimit, {
                  amount: limit.Amount || '',
                  currency: currency,
                  id: limit.Id,
                  handlePickLimit: handlePickLimit
                });
              })
            ),
            !activeLimit && canceledLimit && React.createElement(ActiveLimit, {
              amount: canceledLimit.Amount || '',
              remainingAmount: canceledLimit.RemainingAmount,
              status: canceledLimit.Status,
              timespan: canceledLimit.Timespan,
              currency: currency,
              type: type
            }),
            timespan && !activeLimit && !canceledLimit && React.createElement(
              'div',
              { className: 'limit-info-container' },
              React.createElement(Translate, {
                id: 'message.responsiblegaming.no-limit-set.' + timespan,
                defaultMessage: 'No limits yet',
                values: {
                  title: React.createElement(Translate, { id: title })
                }
              })
            ),
            timespan && !pendingLimit && !multipleLimits && !(reviewLimit && type === 'Deposit' && timespan === reviewLimit.Timespan) && !confirmLimit && (!cooldownLimit || !activeLimit) && React.createElement(
              'div',
              { className: 'custom-amount' },
              React.createElement(Input, { value: type, name: 'Type', type: 'hidden' }),
              React.createElement(
                'div',
                {
                  className: 'custom-amount-decrement',
                  onClick: handleDecrement },
                React.createElement(Icon, { icon: 'minus' })
              ),
              React.createElement(Input, {
                className: 'custom-amount-input',
                onChange: handleLimitAmount,
                name: 'Amount',
                type: type === 'LoginTime' ? 'text' : 'number',
                maxLength: type === 'LoginTime' ? '3' : '',
                pattern: '[0-9]*',
                inputMode: 'numeric',
                min: '1',
                max: '99999999',
                value: amount || '',
                placeholder: timespan && !activeLimit && !canceledLimit ? translate({
                  id: 'label.no-limit-set',
                  defaultMessage: 'No limit'
                }, intl) : null,
                label: type === 'LoginTime' ? translate({
                  id: 'label.hours-short',
                  defaultMessage: 'h'
                }, intl) : null,
                currency: type !== 'LoginTime' ? currency : null
              }),
              React.createElement(
                'div',
                {
                  className: 'custom-amount-increment' + (activeLimit && amount >= activeLimit.Amount && hasDepositLimitIncreaseBlock ? ' disabled' : ''),
                  onClick: handleIncrement },
                React.createElement(Icon, { icon: 'plus' })
              )
            ),
            !pendingLimit && !multipleLimits && !(reviewLimit && type === 'Deposit' && timespan === reviewLimit.Timespan) && !confirmLimit && timespan !== 0 && (!cooldownLimit || !activeLimit) && React.createElement(
              'div',
              null,
              React.createElement(
                Button,
                {
                  className: 'button primary wide',
                  disabled: !submitButton || isLoading || activeLimit && amount >= activeLimit.amount,
                  isLoading: isLoading,
                  type: 'submit' },
                translate({
                  id: 'action.button.set-limit',
                  defaultMessage: 'Set limit'
                }, intl)
              ),
              React.createElement(
                'div',
                null,
                activeLimit && handleCancel && !hideDeleteButton && React.createElement(
                  Button,
                  {
                    type: 'button',
                    disabled: hasDepositLimitIncreaseBlock,
                    className: 'button tertiary wide' + (hasDepositLimitIncreaseBlock ? ' disabled' : ''),
                    onClick: function onClick() {
                      return handleCancel(activeLimit.Id);
                    } },
                  translate({
                    id: 'action.button.delete-limit',
                    defaultMessage: 'Delete limit'
                  }, intl)
                )
              )
            )
          )
        ),
        confirmLimit && timespan === confirmLimit.Timespan && React.createElement(
          'div',
          { className: 'pending-container' },
          React.createElement(ConfirmLimit, {
            status: confirmLimit.Status,
            amount: confirmLimit.Amount || '',
            timespan: confirmLimit.Timespan,
            currency: currency
          }),
          confirmLimit.Status !== 'Canceled' ? React.createElement(
            Button,
            {
              type: 'button',
              className: 'button primary wide',
              onClick: function onClick() {
                return handleConfirm(confirmLimit.Id);
              } },
            translate({ id: 'action.button.set-limit' }, intl)
          ) : React.createElement(
            Button,
            {
              type: 'button',
              className: 'button primary wide',
              onClick: function onClick() {
                return handleConfirm(confirmLimit.Id);
              } },
            translate({
              id: 'action.button.confirm-limit',
              defaultMessage: 'Confirm limit'
            }, intl)
          ),
          React.createElement(
            Button,
            {
              type: 'button',
              className: 'button tertiary wide',
              onClick: function onClick() {
                return handleDecline(confirmLimit.Id);
              } },
            translate({
              id: 'action.button.undo-limit',
              defaultMessage: 'Reset incoming limit'
            }, intl)
          )
        ),
        pendingLimit && timespan === pendingLimit.Timespan && !confirmLimit && React.createElement(
          'div',
          { className: 'pending-container' },
          React.createElement(Input, { value: type, name: 'Type', type: 'hidden' }),
          React.createElement(Input, { value: amount, name: 'Amount', type: 'hidden' }),
          React.createElement(PendingLimit, {
            date: timeUntilNewLimit,
            amount: pendingLimit.Amount || '',
            timespan: pendingLimit.Timespan,
            currency: currency,
            type: type
          }),
          React.createElement(
            Button,
            {
              className: 'button tertiary wide',
              type: '' + (jurisdiction === 'es' ? 'button' : 'submit'),
              onClick: function onClick() {
                return jurisdiction === 'es' && handleCancel(pendingLimit.Id);
              },
              disabled: isLoading,
              isLoading: isLoading },
            translate({
              id: 'action.button.undo-limit',
              defaultMessage: 'Reset incoming limit'
            }, intl)
          )
        ),
        reviewLimit && timespan === reviewLimit.Timespan && type === 'Deposit' && React.createElement(
          'div',
          { className: 'pending-container' },
          React.createElement(Translate, {
            id: 'message.limits.awaiting-support',
            defaultMessage: 'Your limit of {amount} is awaiting approval.',
            values: {
              amount: React.createElement(FormattedNumber, {
                value: reviewLimit.Amount,
                style: 'currency',
                currency: currency
              })
            }
          }),
          React.createElement(
            Button,
            {
              type: 'button',
              className: 'button tertiary wide',
              onClick: function onClick() {
                return handleCancel(reviewLimit.Id);
              } },
            translate({
              id: 'action.button.confirm-limit',
              defaultMessage: 'Confirm limit'
            }, intl)
          ),
          React.createElement(
            Button,
            {
              type: 'button',
              className: 'button tertiary wide',
              onClick: function onClick() {
                return handleDecline(confirmLimit.Id);
              } },
            translate({
              id: 'action.button.undo-limit',
              defaultMessage: 'Reset incoming limit'
            }, intl)
          )
        ),
        cooldownLimit && timespan === cooldownLimit.Timespan && !confirmLimit && React.createElement(
          'div',
          { className: 'pending-container' },
          React.createElement(Input, { value: type, name: 'Type', type: 'hidden' }),
          React.createElement(Input, { value: amount, name: 'Amount', type: 'hidden' }),
          React.createElement(CooldownLimit, {
            date: timeUntilConfirm,
            amount: cooldownLimit.Amount || '',
            timespan: cooldownLimit.Timespan,
            currency: currency,
            type: type
          }),
          activeLimit && React.createElement(
            Button,
            {
              className: 'button tertiary wide',
              type: 'submit',
              disabled: isLoading,
              isLoading: isLoading },
            translate({
              id: 'action.button.undo-limit',
              defaultMessage: 'Reset incoming limit'
            }, intl)
          )
        ),
        canceledLimit && !activeLimit && !confirmLimit && !cooldownLimit && (timeUntilDelete.props.value > 0 || timeUntilNewLimit.props.value > 0) && React.createElement(
          'div',
          { className: 'pending-container' },
          React.createElement(DeletedLimit, {
            amount: canceledLimit.Amount || '',
            remainingAmount: canceledLimit.RemainingAmount,
            status: canceledLimit.Status,
            jurisdiction: jurisdiction,
            date: jurisdiction === 'UK' && timeUntilDelete ? timeUntilDelete : timeUntilNewLimit,
            timespan: canceledLimit.Timespan,
            currency: currency,
            type: type
          })
        ),
        transactionLimit && React.createElement(TransactionLimit, {
          amount: transactionLimit.Amount || '',
          id: transactionLimit.Id,
          currency: currency,
          handleCancel: handleCancel
        })
      );
    }
  }]);

  return AmountItemContent;
}(Component);

export default injectIntl(AmountItemContent);